enum SolIconSizeEnum {
  s12 = '12',
  s16 = '16',
  s20 = '20',
  s24 = '24',
  s28 = '28',
  s32 = '32',
  s36 = '36',
  s40 = '40',
  s44 = '44',
  s56 = '56',
}

type SolIconSize = `${SolIconSizeEnum}`;

export {SolIconSizeEnum, SolIconSize};
